import { AnalyticsDashboard } from "../types";
import { TrendChart } from "./AnalyticsVisuals";

const StockMovementChart = ({ dashboard }: { dashboard?: AnalyticsDashboard | null }) => <TrendChart dashboard={dashboard} movement />;

export default StockMovementChart;
